import { Stack } from 'expo-router';
import { CommunitiesHeader } from '~/components/layout/CommunitiesHeader';
import { useIsLargeScreen } from '~/hooks/useIsLargeScreen';
import { CommunitiesFooter } from '~/components/layout/CommunitiesFooter';

export default function AuthLayout() {
  const isLargeScreen = useIsLargeScreen();
  
  return <>
    <Stack
      screenOptions={{
        header: () => (
          <CommunitiesHeader
            title="Grokio Communities"
            headerClassName="bg-neutral-800"
            rightIconMode={!isLargeScreen}
            rightNeutral
            hideBackOnRoot
          />
        ),
      }}
    />
    <CommunitiesFooter />
  </>;
}
